<template>
  <li class="has-sub">
    <a href="javascript:;">
      <b class="caret pull-right"></b>
      <i class="fa fa-book"></i>
      <span>Bank Soal</span>
    </a>
    <ul class="sub-menu">
      <subnavigation v-for="(item,index) in items" :item="item" :key="index"></subnavigation>
    </ul>
  </li>
</template>

<script>
import itembankService from '@/services/itembank.js'
import bimbelService from '@/services/bimbel.js'
import SubNavigation from '@/components/itembank/SubNavigation'

export default {
  name: 'itembank-nav',
  components: {
    'subnavigation': SubNavigation
  },
  data: function() {
    return {items: []}
  },
  mounted: function() {
    var context = this
    itembankService.getListMataPelajaran(function(result) {
      if(result.success) {
        localStorage.setItem('mapels', JSON.stringify(result.data))
        result.data.forEach(function(item) {
          context.items.push(item)
        })
      }
    })
    bimbelService.getListKurikulum(function(result) {
      if(result.success) {
        localStorage.setItem('kurikulum', JSON.stringify(result.data))
        result.data.forEach(function(item) {
          context.items.push(item)
        })
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// Navigation.vue?e136e306